
import { IAPIJobForUser, IAPILocation } from '@hokify/common';
import { defineComponent } from 'vue';
import type { PropType } from 'vue';
import { getDistanceInKm } from '../helpers/distance';

export default defineComponent({
	name: 'JobFacts',
	data() {
		return {
			showAllTypes: false
		};
	},
	computed: {
		distance() {
			return this.userLocation && getDistanceInKm(this.job.location, this.userLocation);
		},
		addressRegion() {
			return this.job.location?.county?.toUpperCase() || this.job.internal?.region?.toUpperCase();
		},
		jobRegion() {
			return this.job?.internal?.region;
		},
		shownJobTypes(): string[] | undefined {
			if (this.showAllTypes) {
				return this.job?.types;
			}
			return this.job?.types?.slice(0, 3);
		}
	},
	props: {
		job: { type: Object as PropType<IAPIJobForUser>, required: true },
		mobileCompanyPreview: { type: Boolean, default: false },
		additionalJobData: { type: Object, required: false },
		styling: {
			type: String,
			default: 'list-small',
			validator: (value: string) => ['list-small', 'list-base'].includes(value)
		},
		userLocation: {
			type: Object as PropType<IAPILocation>,
			required: false
		},
		grossNet: { type: Boolean, default: true },
		isPwa: { type: Boolean, default: false }
	}
});
